import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@node_modules/@angular/material';


@Component({
    selector: 'app-onboarding-register',
    templateUrl: './onboarding-register.component.html',
    styleUrls: ['./onboarding-register.component.scss']
})

export class OnboardingRegisterComponent implements OnInit {
    static modalRef;

    constructor(
        public dialog: MatDialog,
    ) {
    }

    ngOnInit() {
    }

    close() {
        if (OnboardingRegisterComponent.modalRef) {
            OnboardingRegisterComponent.modalRef.close();
        }
    }
}
